import { defineComponent as _defineComponent } from 'vue'
import { sortBy } from 'lodash'
import { computed, reactive } from 'vue'
import { useGetLocationTypesQuery } from '@/api/location-types'
import AutoComplete from '@/components/common/AutoComplete.vue'
import { useGetLocationStatusesQuery } from '@/api/locations'
import VsWrapper from '@/components/vision/VsWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationAdditionalInfo',
  props: {
    location: null
  },
  emits: ["updated"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updated', data: { field: string; value: any }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  location: {
    locationTypeId?: number | null
    colorId?: number | null
    canEdit?: boolean | null
  }
}



const locationType = reactive({
  isDialogVisible: false,
  searchText: '',
})
const status = reactive({
  isDialogVisible: false,
  searchText: '',
})

const disabled = computed(() => !props.location.canEdit)

const { data: locationTypes, isFetched: fetchedTypes } =
  useGetLocationTypesQuery({ includeUnused: true })

const locationTypesForAutoComplete = computed(() => {
  const types = locationTypes.value?.map((locationType) => {
    return {
      text: locationType.name,
      value: locationType.id,
      icon: locationType.iconId || 'mdi-map-marker',
    }
  })

  return sortBy(types, 'text')
})

const { data: statuses, isFetched: fetchedStatuses } =
  useGetLocationStatusesQuery()
const statusesForAutocomplete = computed(() => {
  return statuses.value?.map((s) => ({
    text: s.name,
    value: s.id,
    color: s.hexCode,
  }))
})


function handleLocationUpdate(data: { field: string; value: any }) {
  emit('updated', data)
}
function handleDialogClose() {
  locationType.isDialogVisible = false
  status.isDialogVisible = false
}
function handleAddLocationType(value: string) {
  locationType.searchText = value || ''
  locationType.isDialogVisible = true
}
function handleAddStatus(value: string) {
  status.searchText = value || ''
  status.isDialogVisible = true
}

return { __sfc: true,props, locationType, status, disabled, locationTypes, fetchedTypes, locationTypesForAutoComplete, statuses, fetchedStatuses, statusesForAutocomplete, emit, handleLocationUpdate, handleDialogClose, handleAddLocationType, handleAddStatus, AutoComplete, VsWrapper }
}

})